/**
 * Loume — Footer
 * ==============
 *
 * <lo-newsletter>     Datenschutz-Checkbox erst zeigen, wenn jemand tippt.
 * <lo-footer-spalte>  Menüspalte, die mobil auf- und zuklappt.
 *
 * Beides verändert nur, was ohne Skript schon funktioniert: ohne JavaScript
 * steht die Checkbox von Anfang an da, und die Menüspalten sind offen.
 */
(function () {
  /**
   * <lo-newsletter>
   *
   * Solange das E-Mail-Feld leer ist, trägt das Element data-einwilligung-zu;
   * das CSS klappt die Checkbox dann weg (und nimmt sie per visibility aus
   * Tab-Reihenfolge und Vorlesen). Beim ersten Tastendruck öffnet sie sich
   * und bleibt offen.
   *
   * Füllt der Browser das Feld ohne input-Ereignis aus und jemand schickt
   * ab, meldet die Pflicht-Checkbox „invalid" — dann öffnet sie sich ebenfalls,
   * und der nächste Versuch zeigt den Hinweis des Browsers direkt an ihr.
   */
  class LoumeNewsletter extends HTMLElement {
    connectedCallback() {
      if (this.bereit) return;
      this.eingabe = this.querySelector('input[type="email"]');
      this.einwilligung = this.querySelector('[data-einwilligung]');
      if (!this.eingabe || !this.einwilligung) return;
      this.bereit = true;

      this.oeffnen = this.oeffnen.bind(this);
      this.beimTippen = this.beimTippen.bind(this);

      if (this.eingabe.value.trim() === '') {
        this.setAttribute('data-einwilligung-zu', '');
      }

      this.eingabe.addEventListener('input', this.beimTippen);
      this.eingabe.addEventListener('change', this.beimTippen);
      this.einwilligung.addEventListener('invalid', this.oeffnen, true);
    }

    disconnectedCallback() {
      if (!this.bereit) return;
      this.eingabe.removeEventListener('input', this.beimTippen);
      this.eingabe.removeEventListener('change', this.beimTippen);
      this.einwilligung.removeEventListener('invalid', this.oeffnen, true);
      this.bereit = false;
    }

    beimTippen() {
      if (this.eingabe.value !== '') this.oeffnen();
    }

    oeffnen() {
      this.removeAttribute('data-einwilligung-zu');
    }
  }

  /**
   * <lo-footer-spalte>
   *
   * Der Umschalter liegt schon im Markup (hidden), das CSS zeigt ihn nur
   * mobil und nur mit data-bereit. Auf breiten Bildschirmen bleibt die Liste
   * immer offen; die Klappe betrifft allein die mobile Darstellung.
   */
  class LoumeFooterSpalte extends HTMLElement {
    connectedCallback() {
      if (this.knopf) return;
      this.knopf = this.querySelector('.loume-footer__umschalter');
      if (!this.knopf) return;

      this.umschalten = this.umschalten.bind(this);
      this.knopf.hidden = false;
      this.knopf.setAttribute('aria-expanded', 'false');
      this.removeAttribute('data-offen');
      this.knopf.addEventListener('click', this.umschalten);
      this.setAttribute('data-bereit', '');
    }

    disconnectedCallback() {
      if (this.knopf) this.knopf.removeEventListener('click', this.umschalten);
      this.knopf = null;
    }

    umschalten() {
      var offen = !this.hasAttribute('data-offen');
      this.toggleAttribute('data-offen', offen);
      this.knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
    }
  }

  /**
   * <lo-cookie-link>
   *
   * Knopf „Cookie-Einstellungen“ in den Rechtslinks. Shopify stellt
   * window.privacyBanner.showPreferences() bereit, lädt es aber erst nach
   * dem Theme — deshalb kurz nachsehen, bis es da ist. Gibt es die Funktion
   * nicht (Banner im Admin aus, Skript blockiert), bleibt der Eintrag
   * versteckt statt eines toten Knopfs.
   */
  class LoumeCookieLink extends HTMLElement {
    connectedCallback() {
      if (this.knopf) return;
      this.knopf = this.querySelector('button');
      if (!this.knopf) return;
      this.oeffnen = this.oeffnen.bind(this);
      this.knopf.addEventListener('click', this.oeffnen);
      this.versuche = 0;
      this.suchen();
    }

    disconnectedCallback() {
      if (this.knopf) this.knopf.removeEventListener('click', this.oeffnen);
      clearTimeout(this.zeitgeber);
      this.knopf = null;
    }

    suchen() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        var eintrag = this.closest('[data-cookie-link]');
        if (eintrag) eintrag.hidden = false;
        return;
      }
      if (++this.versuche > 20) return;
      this.zeitgeber = setTimeout(this.suchen.bind(this), 500);
    }

    oeffnen() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    }
  }

  /**
   * Kurztexte für Shopifys Cookie-Banner und -Einstellungen
   *
   * Shopify fügt Banner (#shopify-pc__banner) und Dialog (#shopify-pc__prefs)
   * selbst ein, mit langen, im Dialog gesiezten Texten. Die Kurztexte stehen
   * als Footer-Einstellungen in #loume-cookie-texte. Ein Beobachter setzt sie
   * ein, sobald Shopify die Elemente anlegt oder neu befüllt. Leere Felder
   * lassen Shopifys Text stehen; ohne Skript bleibt ohnehin alles bei Shopify.
   */
  function cookieTexte() {
    var quelle = document.getElementById('loume-cookie-texte');
    if (!quelle) return;
    var t;
    try {
      t = JSON.parse(quelle.textContent);
    } catch (e) {
      return;
    }

    function setzen(el, text) {
      if (el && text && el.textContent !== text) el.textContent = text;
    }

    // Beschriftung eines <label>, das außerdem Checkbox und Symbol enthält:
    // nur den Textknoten tauschen.
    function labelSetzen(label, text) {
      if (!label || !text) return;
      for (var i = 0; i < label.childNodes.length; i++) {
        var knoten = label.childNodes[i];
        if (knoten.nodeType === 3 && knoten.textContent.trim() !== '') {
          if (knoten.textContent !== text) knoten.textContent = text;
          return;
        }
      }
    }

    function banner() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return;
      setzen(b.querySelector('#shopify-pc__banner__body-title'), t.bannerTitel);
      var absatz = b.querySelector('.shopify-pc__banner__body p');
      var link = b.querySelector('#shopify-pc__banner__body-policy-link');
      if (absatz && link && t.bannerText) {
        setzen(link, t.bannerLink);
        var erster = absatz.firstChild;
        if (!(absatz.childNodes.length === 3 && erster.nodeType === 3 && erster.textContent === t.bannerText + ' ')) {
          absatz.textContent = '';
          absatz.append(t.bannerText + ' ', link, '.');
        }
      }
      setzen(b.querySelector('#shopify-pc__banner__btn-manage-prefs span'), t.bannerVerwalten);
    }

    function dialog() {
      var d = document.getElementById('shopify-pc__prefs');
      if (!d) return;
      setzen(d.querySelector('#shopify-pc__prefs__header-title'), t.dialogTitel);
      setzen(d.querySelector('#shopify-pc__prefs__header-accept'), t.alleAkzeptieren);
      setzen(d.querySelector('#shopify-pc__prefs__header-decline'), t.alleAblehnen);
      setzen(d.querySelector('#shopify-pc__prefs__header-save'), t.speichern);
      // Text direkt unter der Überschrift: Shopifys Standardtext mit Link zur
      // Datenschutzerklärung (Gründer, 27.09.2026). Shopifys eigene Einleitung
      // weiter unten entfällt, dort steht nur noch der Link „Einstellungen“.
      var einleitung = d.querySelector('.shopify-pc__prefs__intro-main');
      var kopf = d.querySelector('#shopify-pc__prefs__dialog header');
      var titel = d.querySelector('#shopify-pc__prefs__header-title');
      if (einleitung && kopf && titel && t.dialogText) {
        einleitung.querySelectorAll('h3, p').forEach(function (el) {
          if (!el.hidden) el.hidden = true;
        });
        if (!kopf.querySelector('.loume-cookie-kopftext')) {
          var absatz = document.createElement('p');
          absatz.className = 'loume-cookie-kopftext';
          absatz.append(t.dialogText + ' ');
          if (t.dialogLink && t.datenschutzUrl) {
            var link = document.createElement('a');
            link.href = t.datenschutzUrl;
            link.target = '_blank';
            link.rel = 'noopener';
            link.textContent = t.dialogLink;
            absatz.append(link);
          }
          titel.after(absatz);
        }
      }
      var erklaerung = d.querySelector('.shopify-pc__prefs__intro-explain');
      if (erklaerung && !erklaerung.hidden) erklaerung.hidden = true;
      ['essential', 'preferences', 'marketing', 'analytics'].forEach(function (art) {
        var option = d.querySelector('#shopify-pc__prefs__' + art);
        if (!option || !t[art]) return;
        labelSetzen(option.querySelector('label'), t[art][0]);
        setzen(option.querySelector('p'), t[art][1]);
      });
      einstellungenZuklappen(d);
    }

    // Die einzelnen Kategorien liegen hinter dem Link „Einstellungen“
    // (Gründer, 27.09.2026): Beim Öffnen stehen nur „Alle akzeptieren“ und
    // „Alle ablehnen“ da; der Link klappt Kategorien und „Auswahl speichern“
    // auf. Jedes neue Öffnen beginnt wieder zugeklappt.
    function einstellungenZuklappen(d) {
      var fenster = d.querySelector('#shopify-pc__prefs__dialog');
      var optionen = d.querySelector('.shopify-pc__prefs__options');
      var einleitung = d.querySelector('.shopify-pc__prefs__intro-main');
      if (!fenster || !optionen || !einleitung || !t.dialogDetails) return;
      if (fenster.querySelector('.loume-cookie-details')) return;

      optionen.id = optionen.id || 'loume-cookie-optionen';
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'loume-cookie-details';
      knopf.textContent = t.dialogDetails;
      knopf.setAttribute('aria-controls', optionen.id);
      einleitung.appendChild(knopf);

      function zu() {
        fenster.setAttribute('data-loume-zu', '');
        knopf.setAttribute('aria-expanded', 'false');
      }
      knopf.addEventListener('click', function () {
        var offen = fenster.hasAttribute('data-loume-zu');
        fenster.toggleAttribute('data-loume-zu', !offen);
        knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
        if (offen) insBild();
      });
      zu();

      // Auf kleinen Bildschirmen scrollt der ganze Dialog
      // (loume-cookie-banner.css). Nach dem Aufklappen die Kategorien ins Bild
      // holen: „Auswahl speichern“ möglichst oben, darunter die Liste — sonst
      // erschiene auf dem iPhone SE außer diesem Knopf nichts Neues. Passt
      // alles, scrollt nichts.
      function insBild() {
        var speichern = fenster.querySelector('#shopify-pc__prefs__header-save');
        var anker = speichern && speichern.getClientRects().length ? speichern : knopf;
        var oben = fenster.getBoundingClientRect().top + fenster.clientTop;
        var bisAnker = anker.getBoundingClientRect().top - oben - 4; // halbe Knopflücke: vom Knopf davor bleibt nichts stehen
        var bisEnde = optionen.getBoundingClientRect().bottom - oben - fenster.clientHeight;
        var weg = Math.min(bisAnker, bisEnde);
        if (weg <= 1) return;
        var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        fenster.scrollTo({ top: fenster.scrollTop + weg, behavior: ruhig ? 'auto' : 'smooth' });
      }

      // Shopify blendet den Dialog per style aus und wieder ein.
      new MutationObserver(function () {
        if (d.style.display !== 'none') return;
        zu();
      }).observe(d, { attributes: true, attributeFilter: ['style'] });
    }

    var geplant = false;
    function alles() {
      geplant = false;
      banner();
      dialog();
    }
    function planen() {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(alles);
    }

    alles();
    // Shopify hängt Banner und Dialog direkt an <body> und befüllt sie dort;
    // eigene Änderungen lösen den Beobachter zwar erneut aus, setzen() ändert
    // dann aber nichts mehr — keine Schleife.
    new MutationObserver(function (aenderungen) {
      for (var i = 0; i < aenderungen.length; i++) {
        var ziel = aenderungen[i].target;
        if (ziel === document.body || (ziel.closest && ziel.closest('#shopify-pc__banner, #shopify-pc__prefs'))) {
          planen();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cookieTexte);
  } else {
    cookieTexte();
  }

  if (!customElements.get('lo-newsletter')) customElements.define('lo-newsletter', LoumeNewsletter);
  if (!customElements.get('lo-cookie-link')) customElements.define('lo-cookie-link', LoumeCookieLink);
  if (!customElements.get('lo-footer-spalte')) customElements.define('lo-footer-spalte', LoumeFooterSpalte);
})();
